export const isCreditCardValid = (expirationMonth, expirationYear) => {
	const date = new Date()
	const currentYear = date.getFullYear() - 2000
	const lastMonth = date.getMonth()

	if (expirationYear > currentYear) {
		return true
	}

	return parseInt(expirationMonth) > lastMonth
}

export const isDebitCardValid = (expirationMonth, expirationYear) => {
	const date = new Date()
	const currentYear = date.getFullYear() - 2000
	const lastMonth = date.getMonth()

	if (expirationYear > currentYear) {
		return true
	}

	return parseInt(expirationMonth) > lastMonth
}

